/**
 * What the API says about how a ticket came to be where it is.
 *
 * The split between `RoutingState` and `RoutingTrailRow` is a permission boundary, not a
 * convenience. The state — assigned to whom, auto or manual, acknowledged or not — is ordinary
 * ticket information. The trail names *other* people and says why each was passed over, including
 * that somebody is on leave, and that is internal: it never reaches a client response, and the
 * detail is only built for a caller holding `support-routing:manage`.
 */
/** How the current assignee got there. */
export const ASSIGNMENT_TYPE = {
    AUTOMATIC: 'AUTOMATIC',
    MANUAL: 'MANUAL',
    NONE: 'NONE',
};
export const ASSIGNMENT_TYPE_LABELS = {
    AUTOMATIC: 'Routed automatically',
    MANUAL: 'Assigned by hand',
    NONE: 'Unassigned',
};
//# sourceMappingURL=ticket-routing.js.map